// component-counter.js

document.body.addEventListener('click', e => {
  if(!e.target.matches('.js-counter-button')) return;
  const quantity = e.target.closest('.counter').querySelector('.js-counter-quantity');
  if (e.target.classList.contains('js-counter-add')) {
    quantity.value = parseInt(quantity.value) + 1
  } else {
    if (quantity.value > 1) {
        quantity.value = parseInt(quantity.value) - 1
    }
  }
});